var visitingUserCountryCode = window.getDataStorage('VISITING_USER_COUNTRY_CODE');
// {{cu}}
var productCardMarkup = `
 <ul>
 {{#products}}
	<li class="">
      <div class="product-grid-item__image">
        <a class="" href="{{du}}">
          <span class="visually-hidden">{{dt}}</span>
        </a>
        <div class="grid-view-item__image-wrapper product-card__image-wrapper js">
          <div>
            <img class="grid-view-item__image lazyautosizes" src="{{iu}}" />
          </div>
        </div>
        </div>
        <div class="product-grid-item__details">
        <a class="" href="{{du}}" title="{{dt}}"><div class="h4 grid-view-item__title product-card__title" aria-hidden="true">{{dt}}</div></a>
        <p class="product-sku">SKU: {{sku}}</p>
        <p class="product-color">{{vi}}</p>
        <dl class="price" data-price="">
          <span class="price-item price-item--sale money" data-sale-price="">
            <span></span>{{money_price}}
          </span>
        </dl>
        <a href="" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" class="add-to-cart">
			{{#isInCart}}Moved to cart{{/isInCart}}
			{{^isInCart}}Move to cart{{/isInCart}}
        </a>
        <button data-event-id="{{lid}}"  data-variant-id="{{epi}}" data-product-id="{{empi}}" class="remove-item btn btn--primary btn--block product-form__cart-submit">Remove</button>
      </div>
    </li>
  {{/products}}
 </ul>
`;

function getVariantInfo(variants){
  try {
    let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []) , variantinfo;
    if(variantKeys.length > 0){
      variantinfo = variantKeys[0];
      if(variantinfo == "Default Title"){
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch(err){
    return variants;
  }
}

function checkCurrentSite(siteClass) {
  return $('body').attr('class').includes(siteClass);
}

function checkPriceIncludeTax() {
  return $('body').attr('class').includes('price-include-tax');
}

function updatePrice(price) {
  var priceCon = '';

  if (checkPriceIncludeTax()) {
    priceCon = window.slate.Currency.formatMoney(Math.round(price * 1.1) * 100, window.shop.moneyWithCurrencyFormat).replace('.00','').replace(',','');
  } else {
    priceCon = window.slate.Currency.formatMoney(price * 100, window.shop.moneyWithCurrencyFormat).replace('.00','').replace(',','');
  }
  return priceCon;
}
function swymCallbackFn(){
  // gets called once Swym is ready
  var wishlistContentsContainer = document.getElementById("wishlist-items-container");

  _swat.fetchWrtEventTypeET(
    function(products) {
      // Get wishlist items
      var formattedWishlistedProducts = products.map(function(p){
        p = SwymUtils.formatProductPrice(p);    // formats product price and adds currency to product Object
		p.money_price = updatePrice(p.pr);
        p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
        p.variantinfo = (p.variants ? getVariantInfo(p.variants) : "");
        var dtAndSku = p.du.split('#=$sku$=')
        p.du = dtAndSku[0]
        p.sku = dtAndSku[1]

        return p;
      });
      var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {products: formattedWishlistedProducts});
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      if(products.length < 1){
        wishlistContentsContainer.innerHTML = '<p class="empty">Your wishlist is empty.</p>';
        }
      attachClickListeners();

    },
    window._swat.EventTypes.addToWishList
  );
}
if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);


function onAddToCartClick(e){
  e.preventDefault();
  var productId = e.target.getAttribute("data-product-id");
  var variantId = e.target.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart(
   {empi: productId, du: du},
   variantId,
   function() {
     e.target.innerHTML = "Moved to cart";
     window.location.reload();
     console.log("Successfully added product to cart.");
   },
   function(e) {
     console.log(e);
   }
  );
}

function onRemoveItem(e) {
    e.preventDefault();
    var eventId = e.target.getAttribute("data-event-id");
  console.log(eventId)
    var deleteEventSync = function(eventId) {
      return new Promise((resolve) => {
        resolve(window._swat.deleteEvent(eventId))
      })
    }
    //deleteEventSync(eventId)

      //.then(() => window.location.reload())
  }

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymCallbackFn);
				});
			}
		});
	})
}
function attachClickListeners(){
  var addToCartButtons = document.getElementsByClassName("add-to-cart");
  var removeItemButtons = document.getElementsByClassName("remove-item");

  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }

  for (var i = 0; i < removeItemButtons.length; i++) {
    removeItemButtons[i].addEventListener('click', onRemoveBtnClick, false);
  }
}